import Vue from 'vue';
import Router from 'vue-router';
import EventBus from '../event_bus';
import Home from '../views/Home.vue';
import Adverts from '../views/Adverts.vue';
import store from '../store';
import routes from './routes';
import trans from '../trans';
import _ from 'lodash';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
});

// This callback runs before every route change, including on page load.
router.beforeEach(function(to, from, next) {
  const is_authenticated = store.state.auth.authenticated;

  const requires_auth = to.matched.some((route) => _.get(route, 'meta.requiresAuth', false));

  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => {
      if (r.meta !== undefined && r.meta.title !== undefined) return r.meta.title;
    });

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => {
      if (r.meta !== undefined && r.meta.metaTags !== undefined) return r.meta.metaTags;
    });

  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find((r) => {
      return r.meta !== undefined && r.meta.metaTags !== undefined;
    });

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) {
    document.title = trans(nearestWithTitle.meta.title, null, 'Local Rent');
  } else {
    document.title = trans('app.page_home', null, 'Local Rent');
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map((el) =>
    el.parentNode.removeChild(el)
  );

  // Skip rendering meta tags if there are none.
  if (nearestWithMeta) {
    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags
      .map((tagDef) => {
        const tag = document.createElement('meta');
        Object.keys(tagDef).forEach((key) => {
          tag.setAttribute(key, tagDef[key]);
        });
        // We use this to track which meta tags we create, so we don't interfere with other ones.
        tag.setAttribute('data-vue-router-controlled', '');
        return tag;
      })
      // Add the meta tags to the document head.
      .forEach((tag) => document.head.appendChild(tag));
  }

  // Check if the route requires authentication and user is not logged in
  if (requires_auth == true && is_authenticated == false) {
    EventBus.$emit('requiresAuth', next);
    if (from.hash == '') {
      return next({ name: 'home' });
    }
    return next(false);
  }

  // Don't forget to continue
  next();
});

router.afterEach();

export default router;
